import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { engineService } from '@/services/engine-service';
import type { Automation } from '@/types/core/workflow-rule';
import type { UUID } from '@/utils/uuid';

import { engineQueryKeys } from './query-keys';

export function useFindAutomation(
  tenantId?: UUID,
  ruleId?: UUID
): UseQueryResult<Automation | null, Error> {
  return useQuery<Automation | null, Error>({
    queryKey: engineQueryKeys.automationDetail(tenantId, ruleId),
    queryFn: async () => {
      if (!tenantId || !ruleId) return null;
      return engineService.findAutomation(tenantId, ruleId);
    },
    enabled: !!tenantId && !!ruleId,
  });
}
